// extracted by mini-css-extract-plugin
module.exports = {"notification":"_1ocCYths_BxwhwqDPZr-E2","fadein":"I8F9wgAxNqu7BxkFPU3uv","popup":"_1KEKIebAGGUWP-nhkxZhxV"};